<template>
	<div class="con">
		<uploadimg @upload="upload01" ref="upload1" style="display: none;"></uploadimg>
		<div class="title">
			<div class="titles">申请加入共享开发环境</div>
		</div>
		<div style="width: 100%;display: flex;">
			<div class="scroll" style="width: 43%;background: #fff;margin-top: 20px;margin-bottom: 20px;overflow-y: scroll;" :style="{height:height}">
				<div style="width: 92%;margin: 0 auto;height: 100%;">
					<iframe
					  width="100%"
					  height="100%" 
					  scrolling='no' 
					  src="https://www.metabiz.com.cn/html/huanjingjiaru.html" 
					  frameborder="0">
					</iframe>
				</div>
			</div>
			<div style="width: 55%;margin-left: auto;">
			<div class="nav" ref="element">
				<div class="navs" :class="[dataForm.types==2?'navselect':'']" @click="quehuanzuzhi(2)">组织</div>
				<div class="navs" :class="[dataForm.types==1?'navselect':'']" @click="quehuanzuzhi(1)">个人</div>
			</div>
			<div class="cons" ref="element01">
				<div class="cons02">
					<el-form :model="dataForm" ref="dataForm" :inline="false" :rules="rules">
						<el-form-item label="环境名称">
						   <el-input placeholder="" v-model="sname" disabled></el-input>
						</el-form-item>
						<el-form-item style="margin-top: 22px;" label="申请者名称" v-if="dataForm.types==2" :prop="dataForm.types==2?'sname':''">
							<el-input placeholder="请输入" v-model="dataForm.sname"></el-input>
						</el-form-item>
						<el-form-item label="申请者logo"  v-if="dataForm.types==2" class="buxu"></el-form-item>
						<div  v-if="dataForm.types==2" style="display: flex;position: relative;align-items: flex-end;">
							<div class="imgurl" style="width: 80px;height: 80px;">
								<el-image style="width: 100%;height: 100%;border-radius: 10px;"
								v-if="dataForm.slogo"
								 :src="dataForm.slogo"
								  :preview-src-list="[dataForm.slogo]"></el-image>
							</div>
							<div class="shangchuan">
								<el-button type="text" @click="dianjis(2)">点击上传</el-button>
								<span style="font-size: 14px;">(85*85)</span>
							</div>
						</div>
						<!--联系人的信息-->
						<el-row style="display: flex;margin-top: 22px;">
							<el-col :span="7">
								<el-form-item label="联系人姓名" class="buxu">
									<el-input placeholder="请输入" v-model="dataForm.name"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="7" style="margin-left: 40px;">
								<el-form-item label="联系人性别" class="buxu">
									<el-select style="width: 100%;" v-model="dataForm.sex" placeholder="请选择">
									    <el-option
									      v-for="item in [{value:'男'},{value:'女'}]"
									      :key="item.value"
									      :label="item.value"
									      :value="item.value">
									    </el-option>
									  </el-select>
								</el-form-item>
							</el-col>
							<el-col :span="7" style="margin-left: auto;" v-if="dataForm.types==1">
								<el-form-item label="联系人电话" prop="phone">
									<el-input type="number" placeholder="请输入" v-model="dataForm.phone"></el-input>
								</el-form-item>
							</el-col>
							<el-col :span="7" v-if="dataForm.types==2" style="margin-left: auto;">
								<el-form-item label="用户数" prop="usernum">
									<el-input placeholder="请输入" v-model="dataForm.usernum" type="number">
									</el-input>
								</el-form-item>
							</el-col>
						</el-row>
					</el-form>
				</div>
			</div>
			</div>
		</div>
		<div style="width: 100%;display: flex;align-items: center;justify-content: center;padding-bottom: 30px;">
			<el-checkbox v-model="checked">我已仔细阅读并接受上述SasS最终用户协议</el-checkbox>
			<el-button style="width: 100px;border-radius: 40px;margin-left: 20px;" type="primary" @click="save">提交</el-button>
		</div>
	</div>
</template>

<script>
	import uploadimg from "@/common/ImgUpload.vue"
	import { user_gongxiang_save } from "@/api/huanjing"
	import { isMobile } from "@/utils/rules"
	export default {
		components:{
			uploadimg
		},
		name:"hj03",
		data(){
			return{
				dataForm:{
					types:2,//1个人 2组织
					slogo:'',//环境图标
					sname:'',//申请者名称 types为2时必填
					slogo:'',//申请者logo 85*85
					lname:'',//联系人姓名
					lsex:'',//联系人性别
					phone:'',//联系人电话
					huanjingid:''
				},
				rules:{
					title:[{ required: true, message: '不能为空', trigger: 'blur' }],
					sname:[{ required: true, message: '不能为空', trigger: 'blur' }],
					phone:[{ required: true, message: '不能为空', trigger: 'blur' }],
					mysql:[{ required: true, message: '不能为空', trigger: 'blur' }],
				},
				imgtype:1,//1环境图标 2申请者logo
				
				sname:'',
				
				height:'0px',
				checked:false,
			}
		},
		watch:{
		},
		mounted(){
			console.log(this.$route.query);
			this.dataForm.huanjingid = this.$route.query.huanjingid
			this.sname = this.$route.query.title
			
			this.height = (this.$refs.element.offsetHeight + this.$refs.element01.offsetHeight) + 'px'
		},
		methods:{
			quehuanzuzhi(types){
				this.dataForm.types = types
				this.height = (this.$refs.element.offsetHeight + this.$refs.element01.offsetHeight) + 'px'
			},
			async save(){
				let that = this;
				if(!that.checked){
					this.$message.error("请勾选协议");
					return;
				}
				that.$refs['dataForm'].validate((valid) => {
					if (valid) {
						if(this.dataForm.types==1 && !isMobile(that.dataForm.phone)){
							this.$message.error("手机号格式不正确");
							return;
						}
						console.log("请求的参数",that.dataForm);
						const loading = this.$loading({
						    lock: true,
						    text: '提交中',
						    spinner: 'el-icon-loading',
						    background: 'rgba(0, 0, 0, 0.7)'
						  });
						user_gongxiang_save(that.dataForm).then(res=>{
							loading.close();
							that.$message.success("提交成功");
							//此时携带orderid跳转到订单页面
							console.log(res.data.orderid);
							this.$router.push({
								path:"/neirong",
								query:{
									orderid:res.data.orderid,
									neirongtype:1,
								}
							})
						}).catch(()=>{
							loading.close();
						})
					}else{
						
					}
				})
			},
			dianjis(type){
				this.imgtype = type
				//环境图标
				this.$refs.upload1.handleUpload();
			},
			upload01(file){
				console.log(file,this.imgtype);
				let that = this;
				if(that.imgtype==1){
					that.dataForm["slogo"] = file
				}
				if(this.imgtype==2){
					that.dataForm["slogo"] = file
				}	
			},
		},
	}
</script>

<style lang="scss" scoped>
	.shangchuan{
		margin-left: 10px;
	}
	/deep/ .buxu{
		margin-bottom: 0px!important;
	}
	/deep/ .el-input__inner{
		background: #f6f8f9!important;
	}
	/deep/ .el-form-item__label:before {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
		display: none;
	}
	/deep/ .el-form-item__label:after {
		content: '*';
		color: #F56C6C;
		margin-left: 4px;
	}
	/deep/ .buxu .el-form-item__label:after {
		content: '*';
		color: #F56C6C;
		margin-right: 4px;
		display: none;
	}
	.imgurl{
		width: 100px;
		height: 100px;
		border: 1px solid #dfdfdf;
		border-radius: 10px;
		img{
			width: 100%;
			height: 100%;
			border-radius: 10px;
		}
	}
	.con{
		.cons{
			width: 100%;
			display: flex;
			padding-top: 30px;
			padding-bottom: 30px;
			.cons01{
				width: 30%;
				.co01{
					color: #333;
					font-size: 18px;
				}
				.co02{
					width: 30px;
					height: 2px;
					background: #00a9f2;
					margin-top: 5px;
				}
				.co03{
					color: #666;
					font-size: 14px;
					margin-top: 15px;
				}
			}
			.cons02{
				width: 100%;
			}
		}
		.navselect{
			background: #00a9f2;
			color: #fff!important;
		}
		.nav{
			width: 100%;
			height: 80px;
			border-bottom: 1px solid #dfdfdf;
			display: flex;
			align-items: center;
			cursor: pointer;
			.navs{
				width: 100px;
				height: 40px;
				border-radius: 30px;
				display: flex;
				align-items: center;
				justify-content: center;
				color: #333;
				font-size: 16px;
			}
		}
		.title{
			width: 100%;
			height: 50px;
			border-bottom: 1px solid #dfdfdf;
			position: relative;
			.titles{
				height: 30px;
				color: #333;
				font-size: 26px;
				position: absolute;
				bottom: 20px;
				right: 30px;
			}
		}
		width: 1200px;
		margin: 0 auto;
	}
</style>


// WEBPACK FOOTER //
// src/views/huanjing/save/gongxiangsave.vue